import { render, staticRenderFns } from "./InstructionBook.vue?vue&type=template&id=4e9ccf66&scoped=true&"
import script from "./InstructionBook.vue?vue&type=script&lang=js&"
export * from "./InstructionBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9ccf66",
  null
  
)

export default component.exports